import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M10.125,2.5 L1.625,2.5 C1.55625,2.5 1.5,2.55625 1.5,2.625 L1.5,4.625 C1.5,4.69375 1.55625,4.75 1.625,4.75 L2.5,4.75 C2.56875,4.75 2.625,4.69375 2.625,4.625 L2.625,3.625 L5.25,3.625 L5.25,12.375 L3.8125,12.375 C3.74375,12.375 3.6875,12.43125 3.6875,12.5 L3.6875,13.375 C3.6875,13.44375 3.74375,13.5 3.8125,13.5 L7.9375,13.5 C8.00625,13.5 8.0625,13.44375 8.0625,13.375 L8.0625,12.5 C8.0625,12.43125 8.00625,12.375 7.9375,12.375 L6.5,12.375 L6.5,3.625 L9.125,3.625 L9.125,4.625 C9.125,4.69375 9.18125,4.75 9.25,4.75 L10.125,4.75 C10.19375,4.75 10.25,4.69375 10.25,4.625 L10.25,2.625 C10.25,2.55625 10.19375,2.5 10.125,2.5 Z M14.3875,11.03125 L13.375,11.03125 L13.375,4.96875 L14.3875,4.96875 C14.48125,4.96875 14.534375,4.859375 14.4765625,4.7859375 L12.9015625,2.7921875 C12.85625,2.734375 12.76875,2.734375 12.725,2.7921875 L11.15,4.7859375 C11.0921875,4.859375 11.14375,4.96875 11.2390625,4.96875 L12.25,4.96875 L12.25,11.03125 L11.2375,11.03125 C11.14375,11.03125 11.090625,11.140625 11.1484375,11.2140625 L12.7234375,13.20625 C12.76875,13.2640625 12.85625,13.2640625 12.9,13.20625 L14.475,11.2140625 C14.534375,11.140625 14.48125,11.03125 14.3875,11.03125 L14.3875,11.03125 Z"
        fillRule="nonzero"
      />
    </svg>
  )
}
const FontLineHeightIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontLineHeightIcon
